import { render, staticRenderFns } from "./SaaS.vue?vue&type=template&id=0942c1fb&scoped=true"
import script from "./SaaS.vue?vue&type=script&lang=js"
export * from "./SaaS.vue?vue&type=script&lang=js"
import style0 from "./SaaS.vue?vue&type=style&index=0&id=0942c1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942c1fb",
  null
  
)

export default component.exports